class Anchor {
  constructor() {
    this.handleInitialHashScroll();
  }

  handleInitialHashScroll() {
    window.addEventListener('load', () => {
      const hash = window.location.hash;
      if (hash) {
        const target = document.querySelector(hash);
        if (target) {
          // Wait for layout to stabilize before scrolling
          setTimeout(() => {
            const offset = this.getHeaderOffset(); // dynamically calculate offset
            const top = target.getBoundingClientRect().top + window.scrollY - offset;

            window.scrollTo({
              top,
              behavior: 'smooth'
            });
          }, 50); // Adjust delay if needed
        }
      }
    });
  }

  getHeaderOffset() {
    const header = document.querySelector('.wp-header');
    let offset = 0;

    if (header) {
      const headerStyles = getComputedStyle(header);
      offset += parseInt(headerStyles.height, 10) || 0;
    }

    // Check if <html> has the 'admin-bar' class
    if (document.documentElement.classList.contains('admin-bar')) {
      offset += 32;
    }

    return offset;
  }

}


export default Anchor;
